(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("qrcodegeneratorts", [], factory);
	else if(typeof exports === 'object')
		exports["qrcodegeneratorts"] = factory();
	else
		root["qrcodegeneratorts"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition